import { SubLoginService } from './../../api/services/sub-login.service';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Observable, map, startWith } from 'rxjs';
import { TbRegisto } from 'src/app/api/models';
import { User } from 'src/app/api/models/getUsers';
import { ProfileDataRequest } from 'src/app/api/models/perfil';
import {
  DeliveryAddress,
  GroupSubClient,
  SearchStatsModel,
  StatisticsViewModel,
  TbLaboratorio,
  TbProduto,
  TbSub,
  YearValues,
} from 'src/app/api/models/statistics';
import { TbCliente } from 'src/app/api/models/tb-cliente';
import { PerfilService } from 'src/app/api/services/perfil.service';
import { SnackBarService } from 'src/app/api/services/snack-bar.service';
import { StatisticsService } from 'src/app/api/services/statistics.service';
import { StatisticsComponent } from 'src/app/Main/statistics/statistics.component';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, NativeDateAdapter} from "@angular/material/core";

export const CUSTOM_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export class CustomDateAdapter extends NativeDateAdapter {
  override format(date: Date, displayFormat: Object): string {
    return this._toDateString(date);
  }

  private _toDateString(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
}

@Component({
    selector: 'app-stats-filter',
    templateUrl: './stats-filter.component.html',
    styleUrls: ['./stats-filter.component.css'],
    providers: [
        { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
        { provide: DateAdapter, useClass: CustomDateAdapter },
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // Setting locale to use dd/MM/yyyy
    ],
    standalone: false
})
export class StatsFilterComponent {
  profileRequest: ProfileDataRequest = this.perfilService.getCurrentUserInfo();
  @Output() isOpen: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() searchStatsEvent = new EventEmitter<SearchStatsModel>();
  @Input() statsViewModel!: StatisticsViewModel;
  @Input() previousSearchModel: SearchStatsModel = {
    userId: this.profileRequest.userId,
    clientEntityId: this.profileRequest.clientId,
    productId: '',
    laboratoryId: '',
    substanceId: '',
    addressId: '',
    startDate: '',
    endDate: '',
    year: '',
  };

  isLoading: boolean = false;
  // statsViewModel: any;
  productsList: TbProduto[];
  substancesList: TbSub[];
  laboratoriesList: TbLaboratorio[];
  deliveryAddressList: DeliveryAddress[];
  yearsList: number[];

  subClients: GroupSubClient[] = [];    /** Sub-clientes apresentados quando o utilizador é um lider de grupo. */
  readonly ALL_SUB_CLIENTS = '';  /** Valor "Todas" no select de sub-clientes. */
  selectedSubClientId: string = this.ALL_SUB_CLIENTS;

  sessionClientNumber = this.profileRequest.clientId;

  selectedProduct?: TbProduto;
  /** Multi-select: products chosen from the autocomplete (chips) */
  selectedProducts: TbProduto[] = [];
  selectedSubstance?: TbSub;
  selectedLaboratory?: TbLaboratorio;
  selectedUserSub?: User;
  selectedAddress?: DeliveryAddress;
  activeProduct: string = '';
  activeSubstance: string = '';
  activeLaboratory: string = '';
  selectedYear: any;
  startDate?: Date;
  endDate?: Date;

  searchStatsModel: SearchStatsModel = {
    userId: '',
    clientEntityId: '',
    productId: '',
    productIds: [],
    laboratoryId: '',
    substanceId: '',
    addressId: '',
    startDate: '',
    endDate: '',
    year: '',
  };

  productControl = new FormControl<string | TbProduto>('');
  filteredProductOptions!: Observable<TbProduto[]>;

  laboratoryControl = new FormControl<string | TbLaboratorio>('');
  filteredLaboratoryOptions!: Observable<TbLaboratorio[]>;

  substanceControl = new FormControl<string | TbSub>('');
  filteredSubstanceOptions!: Observable<TbSub[]>;

  myControl = new FormControl<string | User>('');
  filteredOptions!: Observable<User[]>;
  users: User[] = [];

  constructor(
    private perfilService: PerfilService,
    private statisticsService: StatisticsService,
    private snackBarService: SnackBarService,
    private SubLoginService: SubLoginService
  ) {
    // this.productInput = '';
    this.productsList = [];
    this.substancesList = [];
    this.laboratoriesList = [];
    this.deliveryAddressList = [];
    this.yearsList = [];
    // this.GetStatisticsViewModel(this.sessionClientNumber);
  }

  async ngOnInit() {
    // Monitors everytime there is a text change and filters product list
    this.filteredProductOptions = this.productControl.valueChanges.pipe(
      startWith(''),
      map((value) => {
        let name = typeof value === 'string' ? value : value?.memoria;
        return name
          ? this.FilterProduct(name as string)
          : this.productsList.slice();
      })
    );

    // Monitors everytime there is a text change and filters substance list
    this.filteredSubstanceOptions = this.substanceControl.valueChanges.pipe(
      startWith(''),
      map((value) => {
        let name = typeof value === 'string' ? value : value?.nome;
        return name
          ? this.FilterSubstance(name as string)
          : this.substancesList.slice();
      })
    );

    const currentUser = this.perfilService.getCurrentUserInfo();
    if (currentUser.role === 'Administrador' && currentUser.username.toLocaleLowerCase().startsWith('l')) {
      const clientId = currentUser.clientId;
      const clientName = currentUser.name;
      this.laboratoryControl.setValue({ labName: clientName, id: clientId });
      this.laboratoryControl.disable();
      this.selectedLaboratory = {
        id: currentUser.clientId,
        labName: currentUser.name,
      };
    }

    this.filteredLaboratoryOptions = this.laboratoryControl.valueChanges.pipe(
      startWith(''),
      map((value) => {
        let name = typeof value === 'string' ? value : value?.labName;
        return name
          ? this.FilterLaboratory(name as string)
          : this.laboratoriesList;
      })
    );

    await this.SetupFilters(this.statsViewModel);

    this.HydrateFromPreviousSearch();

    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map((value) => {
        const name = typeof value === 'string' ? value : value?.name;
        return name ? this._filter(name as string) : this.users.slice();
      })
    );
  }

  // Re-applies the most recent search to every filter control so the UI
  // mirrors the active filters whenever the panel is reopened.
  private HydrateFromPreviousSearch(): void {
    const prev = this.previousSearchModel;
    if (!prev) return;

    // Hydrate multi-select chips from previousSearchModel
    const prevIds: string[] = (prev.productIds && prev.productIds.length)
      ? prev.productIds
      : (prev.productId ? [prev.productId] : []);
    if (prevIds.length) {
      this.selectedProducts = prevIds
        .map((id) => this.productsList.find((p) => p.referencia === id))
        .filter((p): p is TbProduto => !!p);
      this.selectedProduct = this.selectedProducts[0];
    }

    if (prev.laboratoryId && !this.laboratoryControl.disabled) {
      const match = this.laboratoriesList.find((l) => l.id === prev.laboratoryId);
      if (match) {
        this.selectedLaboratory = match;
        this.laboratoryControl.setValue(match);
      }
    }

    if (prev.substanceId) {
      const match = this.substancesList.find((s) => s.idSubs === prev.substanceId);
      if (match) {
        this.selectedSubstance = match;
        this.substanceControl.setValue(match);
      }
    }

    if (prev.addressId) {
      const match = this.deliveryAddressList.find(
        (a) => a.clientAddressCode === prev.addressId
      );
      if (match) this.selectedAddress = match;
    }

    if (prev.year) {
      const yearNum = parseInt(prev.year, 10);
      if (!isNaN(yearNum) && this.yearsList.includes(yearNum)) {
        this.selectedYear = yearNum;
      }
    }

    if (prev.startDate) this.startDate = new Date(prev.startDate);
    if (prev.endDate) this.endDate = new Date(prev.endDate);

    if (prev.subClientId && this.subClients.some((u) => u.nCliente === prev.subClientId)) {
      this.selectedSubClientId = prev.subClientId;
    } else {
      this.selectedSubClientId = this.ALL_SUB_CLIENTS;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['previousSearchModel']) {
      let searchModel = changes['previousSearchModel'].currentValue;

      if (searchModel) {
        this.previousSearchModel = changes['previousSearchModel'].currentValue;
      }
    }
  }

  // FUNCTION : Based on data retrieved of the view model, updates the filters with data
  async SetupFilters(viewModel: StatisticsViewModel) {
    this.productsList = viewModel.productsList || [];
    this.substancesList = viewModel.substancesList || [];
    this.laboratoriesList = viewModel.laboratoriesList || [];
    this.deliveryAddressList = viewModel.deliveryAddressesList || [];
    this.subClients = viewModel.group?.groupSubClients ?? [];
    this.yearsList = [];

    let earliastYear: number = 2019;
    let currentYear = new Date().getFullYear();

    while (currentYear >= earliastYear) {
      this.yearsList.push(currentYear);

      currentYear--;
    }

    this.selectedAddress = this.deliveryAddressList[0];
    this.selectedYear = this.yearsList[0];
  }

  CloseMenu(): void {
    this.isOpen.emit(false);
  }

  // Resets every filter control back to its default empty state and emits a
  // search with no filters so the parent reloads the unfiltered dataset.
  ClearFilters(): void {
    this.selectedProduct = undefined;
    this.selectedProducts = [];
    this.productControl.setValue('');

    if (!this.laboratoryControl.disabled) {
      this.selectedLaboratory = undefined;
      this.laboratoryControl.setValue('');
    }

    this.selectedSubstance = undefined;
    this.substanceControl.setValue('');

    this.selectedAddress = this.deliveryAddressList[0];
    this.selectedYear = this.yearsList[0];
    this.startDate = undefined;
    this.endDate = undefined;
    this.selectedSubClientId = this.ALL_SUB_CLIENTS;

    const clearedSearch: SearchStatsModel = {
      userId: '',
      clientEntityId: this.sessionClientNumber,
      productId: '',
      productIds: [],
      laboratoryId: this.profileRequest.role === 'Laboratorio'
        ? this.profileRequest.username.slice(1)
        : '',
      substanceId: '',
      addressId: '',
      startDate: '',
      endDate: '',
      year: this.selectedYear?.toString() ?? new Date().getFullYear().toString(),
      subClientId: '',
    };

    this.previousSearchModel = clearedSearch;
    this.searchStatsEvent.emit(clearedSearch);
  }

  // Function : Responsible for validating the user choices and triggers the search event
  SearchStats() {
    if (
      (this.startDate !== null && this.endDate === null) ||
      (this.endDate !== null && this.startDate === null)
    ) {
      this.snackBarService.openSnackBar(
        'Insira duas datas válidas.',
        '#F97066',
        '../../../assets/Icons/ErrorIcon.png'
      );
      return;
    }

    // Validates if start and end dates are in reasonable intervals
    else if (
      this.startDate != null &&
      this.endDate != null &&
      this.startDate > this.endDate
    ) {
      this.snackBarService.openSnackBar(
        'Data inicial não pode ser superior à final.',
        '#F97066',
        '../../../assets/Icons/ErrorIcon.png'
      );
      return;
    }

    let startDate = '',
      endDate = '';

    if (this.startDate === null && this.endDate === null) {
      startDate = new Date(this.selectedYear.yearValue, 0, 1)
        .toISOString()
        .slice(0, 10);
      this.startDate = new Date(this.selectedYear.yearValue, 0, 1);

      if (this.IsCurrentYear(this.selectedYear)) {
        endDate = new Date().toISOString().slice(0, 10);
        this.endDate = new Date();
      } else {
        endDate = new Date(this.selectedYear.yearValue, 11, 31)
          .toISOString()
          .slice(0, 10);
        this.endDate = new Date(this.selectedYear.yearValue, 11, 31);
      }
    } else {
      startDate = this.startDate
        ? this.startDate.toLocaleDateString('en-CA')
        : '';

      endDate = this.endDate
        ? this.endDate.toLocaleDateString('en-CA')
        : '';
    }


    let laboratoryIdValue = '';

    if (this.profileRequest.role === "Laboratorio") {
      laboratoryIdValue = this.profileRequest.username.slice(1);
    } else {
      laboratoryIdValue = this.selectedLaboratory
        ? this.selectedLaboratory.id
        : '';
    }

    let substanceIdValue = this.selectedSubstance
      ? this.selectedSubstance.idSubs
      : '';

    const productIdsValue = this.selectedProducts.map((p) => p.referencia);
    // Keep singular productId populated only when exactly one product is chosen,
    // for backward-compat with anything still reading it.
    let productIdValue = productIdsValue.length === 1 ? productIdsValue[0] : '';

    this.searchStatsModel = {
      userId: '',
      clientEntityId: this.sessionClientNumber,
      productId: productIdValue as string,
      productIds: productIdsValue,
      laboratoryId: laboratoryIdValue as string,
      substanceId: substanceIdValue as string,
      addressId: this.selectedAddress?.clientAddressCode as string,
      startDate: startDate,
      endDate: endDate,
      year: this.selectedYear.toString(),
      subClientId: this.selectedSubClientId || '',
    };

    this.searchStatsEvent.emit(this.searchStatsModel);
    this.isOpen.emit(false);
  }

  // Auto-fills the date pickers based on the selected year:
  // start = Jan 1 of the year, end = Dec 31 (or today, if current year).
  OnYearChange(year: number): void {
    if (!year || isNaN(year)) return;
    this.startDate = new Date(year, 0, 1);
    this.endDate = this.IsCurrentYear(year) ? new Date() : new Date(year, 11, 31);
  }

  // AUX FUNCTION : Validates if year selected is the current year
  IsCurrentYear(year: number) {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();

    return year == currentYear;
  }

  // PRODUCT AUTOCOMPLETE
  // FUNCTION : Responsible for showcasing the selected product on the input
  DisplayProduct(product: TbProduto): string {
    return product && product.memoria ? `${product.memoria}` : '';
  }

  // FUNCTION : Adds the product to the multi-select chip list and clears the input
  SelectedProduct(event: any) {
    const product: TbProduto = event.option.value;
    if (!product) return;
    this.selectedProduct = product;
    if (!this.selectedProducts.some((p) => p.referencia === product.referencia)) {
      this.selectedProducts = [...this.selectedProducts, product];
    }
    // Clear the autocomplete input so the user can search for another product
    setTimeout(() => this.productControl.setValue(''), 0);
  }

  RemoveSelectedProduct(product: TbProduto) {
    this.selectedProducts = this.selectedProducts.filter((p) => p.referencia !== product.referencia);
    if (this.selectedProduct?.referencia === product.referencia) {
      this.selectedProduct = this.selectedProducts[0];
    }
  }

  // FUNCTION : Filters the list of products based on user input
  private FilterProduct(value: string): TbProduto[] {
    let filterValue = value.toLowerCase();
    return this.productsList.filter((option) =>
      option.memoria.toLowerCase().includes(filterValue) ||
      (option.referencia ?? '').toLowerCase().includes(filterValue)
    );
  }

  // LABORATORY AUTOCOMPLETE
  DisplayLaboratory(laboratory: TbLaboratorio): string {
    return laboratory && laboratory.labName ? `${laboratory.labName}` : '';
  }

  SelectedLaboratory(event: any) {
    this.selectedLaboratory = event.option.value;
  }

  SelectedUserSub(event: any) {
    this.selectedUserSub = event.option.value;
  }

  private FilterLaboratory(value: string): TbLaboratorio[] {
    let filterValue = value.toLowerCase();
    return this.laboratoriesList.filter((option) =>
      option.labName.toLowerCase().includes(filterValue)
    );
  }

  // SUBSTANCE AUTOCOMPLETE
  DisplaySubstance(substance: TbSub): string {
    return substance && substance.nome ? `${substance.nome}` : '';
  }

  SelectedSubstance(event: any) {
    this.selectedSubstance = event.option.value;
  }

  private FilterSubstance(value: string): TbSub[] {
    let filterValue = value.toLowerCase();
    return this.substancesList.filter((option) =>
      option.nome.toLowerCase().includes(filterValue)
    );
  }

  /* Aux */
  displayFn(user: User): string {
    return user && user.name ? `${user.clientNumber} - ${user.name}` : '';
  }

  private _filter(value: string): User[] {
    const filterValue = value.toLowerCase();
    return this.users.filter(
      (option) =>
        option.name.toLowerCase().includes(filterValue) ||
        option.clientNumber.includes(filterValue)
    );
  }
}
